import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { UserCollection } from '@/models/User';
import type { QueryParams } from '@kp/js-model';

/**
 * Creates a reactive connection between a UserCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */
export function useUserCollection(options: UseCollectionOptions = {}, queryParams: QueryParams = {}) {
    const users = new UserCollection();
    users.setQueryParams(queryParams);
    const initialFilters: ApiFilter[] = [];

    const refs = useCollection(users, {
        ...{
            tableSort: [],
            collectionsFilter: initialFilters,
            pageSize: 5
        },
        ...options
    });
    return refs;
}
